import { CustomWallpaperActionType } from './actions';
import { initialState } from './constants';
import { CustomWallpapersState, CustomWallpapersAction } from './types';

export const customWallpapersReducer = (
  state: CustomWallpapersState = initialState,
  action: CustomWallpapersAction
): CustomWallpapersState => {
  switch (action.type) {
    case CustomWallpaperActionType.setCustomWallpaper:
      return {
        customWallpaper: action.payload,
      };
    case CustomWallpaperActionType.clearCustomWallpaper:
      return {
        customWallpaper: null,
      };
    default:
      return state;
  }
};
